import { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { doc, collection, getDoc } from "firebase/firestore";
import { useLocation } from "react-router-dom";
import { firestore } from "../firebase-config";
import { id_firebase } from "../content-site";
import { retiraMascara } from "../utils/retiraMascara";

export default function WhatsappFloatButton() {
    const [telefone, setTelefone] = useState("");
    const location = useLocation();

    useEffect(() => {
        const revendaRef = doc(collection(firestore, "revenda"), id_firebase);
        getDoc(revendaRef).then((docSnap) => {
            if (docSnap.exists()) {
                setTelefone(retiraMascara(docSnap.data().petelefone2, "link"));
            }
        });
    }, []);

    const shouldHide = location.pathname === "/estoque" || location.pathname.startsWith("/veiculo/");

    if (!telefone || shouldHide) return null;

    return (
        <a
            href={`https://api.whatsapp.com/send?phone=55${telefone}&text=${encodeURIComponent("Olá! Gostaria de conhecer melhor a loja e saber como vocês podem me ajudar a encontrar meu próximo carro. Podem me mostrar as opções disponíveis?")}`}
            target="_blank"
            rel="noopener noreferrer"
            className="fixed z-50 bottom-6 right-6 bg-primary hover:bg-primary/90 text-primary-foreground rounded-full shadow-lg p-4 flex items-center justify-center transition-all"
            aria-label="Fale conosco no WhatsApp"
            style={{ boxShadow: "0 4px 16px rgba(0,0,0,0.2)" }}
        >
            <FaWhatsapp className="text-3xl" />
        </a>
    );
}
